import React from "react";
import GeneralTable from "../../components/Table/GeneralTable";
import { useTranslation } from "react-i18next";

export default function Pool() {
    const { t } = useTranslation("translation");

    return (
        <div>
            <GeneralTable
                id="po_gt"
                table="Pool"
                resourcePath="GetDetailedList"
                title={t("Pool")}
                search={t("SearchPool")}
            />
        </div>
    );
}
